"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUsers = exports.useGetGraphUsers = exports.getRestUsers = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const catalog_queries_1 = require("@tableau/catalog-queries");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const axios_1 = tslib_1.__importDefault(require("axios"));
function getUsersRequestConfig(params) {
    return {
        restApiVersion: '3.16',
        serverWideRequest: false,
        endpoint: `users/${params.userLuid}`,
        httpMethod: 'GET',
    };
}
function queryUserOnSite(params) {
    axios_1.default.defaults.baseURL = window.location.origin;
    const makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    const result = makeJsonRestApiRequest(getUsersRequestConfig(params));
    return result;
}
function getRestUsers(luids, params) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { makeJsonRestApiRequest } = (0, vizportalclient_common_components_1.restApiService)(params);
        const result = yield Promise.all(luids.map(t => queryUserOnSite({ userLuid: t, makeJsonRestApiRequest })));
        const users = new Map(result.map(i => { var _a, _b; return [i.user.id, { username: (_a = i.user.name) !== null && _a !== void 0 ? _a : null, name: (_b = i.user.fullName) !== null && _b !== void 0 ? _b : null, domain: i.user.domain.name }]; }));
        return users;
    });
}
exports.getRestUsers = getRestUsers;
function useGetGraphUsers(luids) {
    const { loading, data } = (0, client_1.useQuery)(catalog_queries_1.GetUserDocument, {
        variables: { luids: luids },
        skip: luids.length === 0,
    });
    return { data, loading };
}
exports.useGetGraphUsers = useGetGraphUsers;
function useGetUsers(luids) {
    const { data: graphUsers, loading: graphUsersLoading } = useGetGraphUsers(luids);
    const authors = new Map();
    graphUsers === null || graphUsers === void 0 ? void 0 : graphUsers.items.forEach(val => {
        authors.set(val.luid, { name: val.name, domain: val.domain, username: val.username });
    });
    return { authors, loading: graphUsersLoading };
}
exports.useGetUsers = useGetUsers;
//# sourceMappingURL=getUsers.js.map